import { createSlice } from "@reduxjs/toolkit";

import { UsefulTipsAPI } from "../../services/useful-tips";

const UsefulTips = createSlice({
  name: "UsefulTips slice",
  initialState: {
    usefulTips: [],
    total: 0,
    oneUsefulTip: null,
  },
  reducers: {
    setOneUsefulTip: (state, action) => {
      state.oneUsefulTip = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(UsefulTipsAPI.getAll.fulfilled, (state, action) => {
        const { useful_tips, total } = action.payload;
        
        state.usefulTips = useful_tips;
        state.total = total;
      })
      .addCase(UsefulTipsAPI.getOne.fulfilled, (state, action) => {
        state.oneUsefulTip = action.payload.data;
      });
  },
});

export const { setOneUsefulTip } = UsefulTips.actions;

export default UsefulTips;
